
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Header from './components/Header';
import Game from './components/Game';

function App() {
  return (
    <div className='container'>
      <Header />
      <Game />
    </div>
  );
}

export default App;
